// @ts-strict-ignore
import { Search } from "lucide-react";
import React from "react";

import Card from "./Card";

const headerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 8,
};

const rowStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr 1fr",
  padding: "10px 0",
  alignItems: "center",
  borderBottom: "1px solid #f3f4f6",
};

const badgePaid: React.CSSProperties = {
  background: "#ecfdf5",
  color: "#065f46",
  padding: "4px 8px",
  borderRadius: 6,
  fontSize: 12,
  fontWeight: 700,
  width: 48,
  textAlign: "center",
};

const invoices = [
  { date: "15 Jul 2025", amount: "US$200.00", status: "Paid", plan: "WSM Team Plan" },
  { date: "15 Jun 2025", amount: "US$200.00", status: "Paid", plan: "WSM Team Plan" },
  { date: "15 May 2025", amount: "US$200.00", status: "Paid", plan: "WSM Team Plan" },
  { date: "15 Apr 2025", amount: "US$200.00", status: "Paid", plan: "WSM Team Plan" },
  { date: "15 Mar 2025", amount: "US$200.00", status: "Paid", plan: "WSM Team Plan" },
  { date: "15 Feb 2025", amount: "US$200.00", status: "Paid", plan: "WSM Team Plan" },
  { date: "15 Jan 2025", amount: "US$200.00", status: "Paid", plan: "WSM Team Plan" },
];

const InvoiceHistoryCard: React.FC = () => {
  return (
    <Card>
      <div style={headerStyle}>
        <div style={{ fontWeight: 800, fontSize: 18 }}>Invoice History</div>
        <div title="Search" style={{ cursor: "pointer", display: "flex" }}>
          <Search size={18} />
        </div>
      </div>
      <div>
        {invoices.map((i, idx) => (
          <div key={idx} style={rowStyle}>
            <div>{i.date}</div>
            <div style={{ fontWeight: 700 }}>{i.amount}</div>
            <div>
              <span style={badgePaid}>{i.status}</span>
            </div>
            <div style={{ color: "#374151" }}>{i.plan}</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default InvoiceHistoryCard;
